import React from "react";
import Navbar from "../../partials/Navber";
import Footer from "../../partials/Footer";
import CartModal from "../../partials/CartModal";

const sections = [
  {
    title: "1. Aceitação dos Termos",
    content: `Ao acessar e utilizar o site da Flitz, você declara estar de acordo com estes Termos de Serviço. Caso discorde de qualquer cláusula, recomendamos não utilizar nossos serviços.`,
  },
  {
    title: "2. Uso Permitido",
    content: `O uso do site deve respeitar a legislação vigente e não pode comprometer a experiência de outros usuários. A Flitz se reserva o direito de restringir acessos indevidos ou mal-intencionados.`,
  },
  {
    title: "3. Cadastro e Responsabilidades",
    content: `Para realizar pedidos, é necessário criar uma conta. Você é responsável pelas credenciais de acesso e por manter seus dados atualizados e protegidos.`,
  },
  {
    title: "4. Produtos e Preços",
    content: `Os produtos disponíveis e seus respectivos preços podem ser alterados a qualquer momento, sem aviso prévio. Promoções são válidas enquanto durarem os estoques.`,
  },
  {
    title: "5. Compras e Pagamentos",
    content: `Ao finalizar uma compra, você concorda com os valores e condições exibidas. Um e-mail de confirmação será enviado após o processamento do pedido.`,
  },
  {
    title: "6. Trocas e Devoluções",
    content: `Seguimos o Código de Defesa do Consumidor. Você pode solicitar trocas ou devoluções em até 7 dias após o recebimento. Consulte nossa política detalhada na página correspondente.`,
  },
  {
    title: "7. Limitação de Responsabilidade",
    content: `A Flitz não se responsabiliza por prejuízos resultantes de mau uso do site, falhas técnicas ou uso indevido dos produtos.`,
  },
  {
    title: "8. Atualizações dos Termos",
    content: `Estes termos podem ser atualizados a qualquer momento. A versão mais recente estará sempre disponível neste endereço.`,
  },
  {
    title: "9. Atendimento ao Cliente",
    content: `Em caso de dúvidas ou solicitações, entre em contato através do e-mail: contato@flitzbr.com.br. Teremos prazer em ajudar.`,
  },
];

const Servicos = () => {
  return (
    <>
      <Navbar />
      <main className="bg-white text-gray-800 min-h-screen mt-24 px-6 md:px-20 lg:px-40 py-12">
        <h1 className="text-4xl font-semibold mb-12 text-gray-900 text-center">
          Termos de Serviço - Flitz
        </h1>
        <div className="space-y-16">
          {sections.map((section, index) => (
            <section key={index} className="scroll-mt-24 border-b border-gray-200 pb-10">
              <h2 className="text-2xl font-medium text-gray-900 mb-4">{section.title}</h2>
              <p className="text-base leading-relaxed whitespace-pre-line text-gray-700">
                {section.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
      <CartModal />
    </>
  );
};

export default Servicos;